import * as React from 'react'
import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'

// Colours fall back to the original defaults via CSS var fallbacks, so this button
// is unchanged outside a themed survey. Inside SurveyView the survey-themed wrapper
// sets --survey-button-color / --survey-button-text from the survey's theme.
const CustomButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 14,
  padding: '8px 15px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: 'var(--survey-button-color, #E84F6B)',
  borderColor: 'var(--survey-button-color, #E84F6B)',
  color: 'var(--survey-button-text, #fff)',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: 'var(--survey-button-color, #E82347)',
    borderColor: 'var(--survey-button-color, #E82347)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'var(--survey-button-color, #E84F6B)',
    borderColor: 'var(--survey-button-color, #E84F6B)',
  },
  '&:disabled': {
    boxShadow: 'none',
    borderColor: '#cfcfcf',
  },
  '&:focus': {
    //boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
})

export default function WbButton({CustomButtonText, onClick, ...props}) {
  return (
    <CustomButton
      variant="contained"
      disableRipple
      onClick={onClick}
      {...props}
    >
      {CustomButtonText}
    </CustomButton>
  )
}
